"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _GenericFormElement = _interopRequireDefault(require("../GenericFormElement"));

require("react-datepicker/dist/react-datepicker.css");

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DatePicker = function DatePicker(props) {
  var title = props.title,
      required = props.required,
      description = props.description,
      placeholder = props.placeholder,
      fieldName = props.fieldName,
      validation = props.validation,
      touched = props.touched,
      error = props.error,
      type = props.type,
      value = props.value,
      displayRequiredIndicator = props.displayRequiredIndicator,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/_react.default.createElement(_GenericFormElement.default, {
    className: (0, _classnames.default)('DatePicker', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: touched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    placeholder: placeholder,
    fieldName: fieldName,
    validation: validation,
    touched: touched,
    error: error,
    type: type || 'text',
    value: value
  }, function (_ref) {
    var form = _ref.form;
    return /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
      id: fieldName,
      selected: value && new Date(value) || null,
      onChange: function onChange(value) {
        form.setFieldValue(fieldName, value);
      },
      peekNextMonth: true,
      showMonthDropdown: true,
      showYearDropdown: true,
      dropdownMode: "select",
      className: className,
      disabled: disabled
    });
  }));
};

var _default = DatePicker;
exports.default = _default;